import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ab00b9b4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ab00b9b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab00b9b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab00b9b4')) {
      api.createRecord('ab00b9b4', component.options)
    } else {
      api.reload('ab00b9b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ab00b9b4&scoped=true&", function () {
      api.rerender('ab00b9b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spine/index.vue"
export default component.exports